import CityPageTemplate from "../city-template/CityPageTemplate";
import { everettConfig } from "./data";

export default function EverettPage() {
  return <CityPageTemplate config={everettConfig} />;
}